"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var extend_1 = __importDefault(require("licia/extend"));
var Visitor = (function () {
    function Visitor() {
        this.id = 0;
        this.visited = [];
    }
    Visitor.prototype.set = function (val, extra) {
        var _a = this, visited = _a.visited, id = _a.id;
        var obj = {
            id: id,
            val: val,
        };
        (0, extend_1.default)(obj, extra);
        visited.push(obj);
        this.id++;
        return id;
    };
    Visitor.prototype.get = function (val) {
        var visited = this.visited;
        for (var i = 0, len = visited.length; i < len; i++) {
            var obj = visited[i];
            if (val === obj.val)
                return obj;
        }
        return false;
    };
    return Visitor;
}());
exports.default = Visitor;
